// This file was generated by "make codegen/iam". DO NOT EDIT.
import { allowedActions } from "./allowedActions";

export const roleAgent = {
  id: "agent",
  mrn: "//iam.api.mondoo.app/roles/agent",
  title: "Agent",
  allowedActions,
} as const;

export type RoleAgent = typeof roleAgent;
